export { default as homeAnalytics } from './home.analytics';
